<app-card [title]="title" [icon]="icon">
  <div actions>
    <mat-icon (click)="onActionClick(formRef)" *ngIf="hasCrud()" class="material-symbols-outlined editable-icon-size text-primary cursor-pointer">
      {{actionIcon}}
    </mat-icon>
  </div>
  <ng-content></ng-content>
</app-card>

<ng-template #formRef>
  <app-sidenav [title]="formTitle + ' ' + title" [padding]="0" [className]="'w-full'">
    <div class="flex flex-column gap-3 align-items-center w-full">
      <div #cardFormRef class="w-full p-2">
        <ng-content select="[card-form]"></ng-content>
      </div>
    </div>
    <div footer>
      <div class="flex justify-content-center">
        <app-button label="Salva" raised fullWidth cdkFocusRegionstart (click)="onSaveClick()" [disabled]="!form?.valid"></app-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>
